<template>
  <fn-modal
    :all-close="false"
    :closable="false"
  >
    <div class="ec-images">
      <fn-image
        :height="ecoconsentDogImage.height"
        :src="ecoconsentDogImage.src"
        :width="ecoconsentDogImage.width"
        class="ec-images-img"
      />
      <fn-image
        :height="ecoconsentDogImage.height"
        :src="ecoconsentCatImage.src"
        :width="ecoconsentDogImage.width"
        class="ec-images-img"
      />
    </div>
    <fn-headline
      centered
      class="ec-title"
      color="grey-dark"
      size="h2"
      type="h1"
    >
      {{ $t('login.ecoconsent.title') }}
    </fn-headline>
    <fn-paragraph
      align-center
      class="ec-subtitle"
    >
      {{ $t('login.ecoconsent.subtitle') }}
    </fn-paragraph>
    <fn-form @submit="onSubmit">
      <fn-form-group>
        <fn-form-section>
          <fn-form-field-checkbox
            id="register-userData-doi"
            v-model:value="ecoconsentGranted"
            :rules="{
              required: {
                allowFalse: false,
              },
            }"
            :show-mandatory="false"
            label=""
            type="checkbox"
          >
            <template #afterLabel>
              <i18n-t
                class="ec-checkbox-text"
                keypath="login.ecoconsent.consentText"
                tag="div"
              >
                <template #partnerLink>
                  <fn-link
                    :to="$t('login.ecoconsent.partnerUrl')"
                    inline
                    target="_blank"
                  >
                    {{ $t('login.ecoconsent.partnerLink')
                    }}<!-- prevent whitespace
                -->
                  </fn-link>
                </template>
                <template #privacyLink>
                  <fn-link
                    :to="$t('login.ecoconsent.privacyUrl')"
                    inline
                    target="_blank"
                  >
                    {{ $t('login.ecoconsent.privacyLink')
                    }}<!-- prevent whitespace
                -->
                  </fn-link>
                </template>
              </i18n-t>
            </template>
          </fn-form-field-checkbox>
        </fn-form-section>

        <fn-form-section class="ec-form-actions">
          <fn-button
            id="register-userData-submit"
            full-width
            secondary
            submit
          >
            {{ $t('login.ecoconsent.buttons.confirm') }}
          </fn-button>
          <fn-form-field-info-wrapper>
            <template #default>
              <fn-link
                pre-arrow
                secondary
                @click="$emit('decline')"
              >
                {{ $t('buttons.cancel') }}
              </fn-link>
            </template>
            <template #side>
              <fn-info-i placement="right">
                {{ $t('login.ecoconsent.buttons.infoIcon') }}
              </fn-info-i>
            </template>
          </fn-form-field-info-wrapper>
        </fn-form-section>
      </fn-form-group>
      <fn-form-group v-if="loginRecaptchaEnabled">
        <fn-form-section>
          <fn-recaptcha
            ref="recaptcha"
            no-margin
            small-print
            @verify="handleSubmit"
          />
        </fn-form-section>
      </fn-form-group>
    </fn-form>
  </fn-modal>
</template>
<script>
/* eslint-disable import/no-duplicates */
import { actions } from '@/utils/recaptcha';
import ecoconsentDogImage from '@/assets/img/ecoconsent-dog.svg';
import ecoconsentDogImageSize from '@/assets/img/ecoconsent-dog.svg?imageSize';
import ecoconsentCatImage from '@/assets/img/ecoconsent-cat.svg';
import ecoconsentCatImageSize from '@/assets/img/ecoconsent-cat.svg?imageSize'; /* eslint-enable import/no-duplicates */

export default {
  emits: ['accept', 'decline'],
  data: () => ({
    ecoconsentGranted: false,
    fields: {
      recaptchaResponse: '',
    },
  }),
  computed: {
    ...mapState(useMainStore, {
      loginRecaptchaEnabled: 'getLoginRecaptchaEnabled',
    }),

    ecoconsentDogImage() {
      return {
        src: ecoconsentDogImage,
        ...ecoconsentDogImageSize,
      };
    },

    ecoconsentCatImage() {
      return {
        src: ecoconsentCatImage,
        ...ecoconsentCatImageSize,
      };
    },
  },
  methods: {
    handleSubmit(recaptchaFields = {}) {
      if (this.loginRecaptchaEnabled) {
        this.fields.recaptchaResponse = recaptchaFields.recaptchaResponse;
      }
      this.$emit('accept', this.fields);
    },
    onSubmit() {
      if (this.loginRecaptchaEnabled) {
        this.$refs.recaptcha.execute(actions.login);
      } else {
        this.handleSubmit();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.modal) {
  max-width: 640px;

  .m-content {
    padding: $pad;
    @include bp(m) {
      padding: 28px 92px 43px;
    }
  }

  .checkbox-label-after {
    margin-left: 0;
  }

  .error-message {
    position: absolute;
  }

  .ec-images {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 22px;

    .ec-images-img {
      width: 83px;
      height: auto;
    }
  }

  .ec-title {
    font-weight: map-get($font-weights, 'black');
    margin-bottom: 20px;
  }

  .ec-subtitle {
    margin-bottom: 30px;
  }

  .ec-checkbox-text {
    text-align: center;
    color: palette(grey);
    font-size: map-get($font-sizes, s);
    line-height: 1.3;
  }

  .ec-form-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    row-gap: 20px;
  }
}
</style>
